export default "/profile/images/instruction-3-en.webp?11d6efd7ac0b14cb2baf075a69cfa2ca";